import { useEffect, useRef } from 'react';

/**
 * Notificação do browser quando chega algo novo e a app NÃO está à frente (separador em segundo
 * plano / janela sem foco). É o que dá sentido à permissão «Notificações» pedida nas Definições —
 * antes a permissão era pedida mas nada a usava.
 *
 * LIMITE HONESTO: isto NÃO é Web Push. Funciona enquanto o separador/PWA estiver aberto (a contagem é
 * consultada de 60 em 60 s e ao voltar o foco); com a app fechada não chega nada — isso exige
 * service worker + subscrição push (VAPID), que a app lean ainda não tem (o sw.js é só o interruptor de
 * autodestruição do monólito antigo).
 */
export function useBrowserNotify(total: number | undefined): void {
  const prev = useRef<number | undefined>(undefined);
  useEffect(() => {
    if (total === undefined) return;
    const before = prev.current;
    prev.current = total;
    if (before === undefined || total <= before) return;               // 1.ª leitura ou nada de novo
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
    if (typeof document !== 'undefined' && !document.hidden && document.hasFocus()) return;   // está a olhar: o sino chega
    const novas = total - before;
    try {
      const n = new Notification('Marcianus', {
        body: novas === 1 ? 'Tens 1 notificação nova.' : `Tens ${novas} notificações novas.`,
        tag: 'mx-notificacoes',                                         // várias seguidas fundem-se numa
        icon: '/assets/symbol.png',
      });
      n.onclick = () => { window.focus(); n.close(); };
    } catch { /* alguns browsers móveis exigem service worker: sem ele, o aviso in-app continua */ }
  }, [total]);
}
